import { useContext } from "react";
import { GlobalContext } from "../components/GlobalContext";

export const useRedirectAfterLogin = () => {
  const context = useContext(GlobalContext);
  return [context.redirectAfterLogin, context.setRedirectAfterLogin] as const;
};
